<script>
  export let size = "1rem"
  export let color = "currentColor"
  export let strokeWidth = "1.65"
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  width={size}
  height={size}
  {...$$restProps}
  class="{$$props.class || ''} focus:outline-none"
  viewBox="0 0 24 24"
  stroke-width={strokeWidth}
  stroke={color}
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M8.25 4.5l7.5 7.5-7.5 7.5"
  />
</svg>
